import { useNavigate } from "react-router-dom";
import { createExportButton } from "../../Grid/ExcelExport/CreateExportButton";
import SingleSelectKendoGrid from "../../Grid/Selectable/SingleSelectKendoGrid";
import { defaultAddButton } from "../../Grid/Toolbar/DefaultAddButton";
import { defaultEditButton } from "../../Grid/Toolbar/DefaultEditButton";
import PageHeader from "../../Layout/Header/PageHeader";
import { edcUrls } from "../../URL/ApplicationUrls";
import { combinedUrls } from "../../URL/functions";
import EdcOverviewItem from "./EdcOverviewItem";
import { EdcGridColumns } from "./EdcGridColumns";
import { AuthorizationPolicies } from "../../Auth/AuthorizationPolicy";

function EdcOverview() {
  const navigate = useNavigate();
  const addEdc = () => navigate(edcUrls.addEdc.uiPath);

  const editEdc = (edc: EdcOverviewItem | undefined) =>
    edc && navigate(edcUrls.mutateEdc(edc.Id).uiPath);

  const url = combinedUrls(edcUrls.base.apiUrl, "KendoGrid");

  return (
    <>
      <PageHeader headerText="EDC" />
      <SingleSelectKendoGrid
        localStorageKey="EdcOverviewGrid_DataState"
        fetchUrl={combinedUrls(edcUrls.base.apiUrl, "KendoGrid")}
        columns={EdcGridColumns()}
        idSelector={(edc: EdcOverviewItem) => edc.Id}
        toolbarItems={[
          defaultAddButton({
            onClick: addEdc,
            roles: AuthorizationPolicies.RequireAdminNetworkRoles,
          }),
          defaultEditButton({
            onClick: editEdc,
            roles: AuthorizationPolicies.RequireAdminNetworkRoles,
          }),
        ]}
        onRowDoubleClick={editEdc}
        customToolbarItems={[
          createExportButton({
            url,
            filename: "Edcs",
          }),
        ]}
      />
    </>
  );
}

export default EdcOverview;
